import url_ from "asset-data:assets/galleries/featured/bed_59c9a5248b__1600.jpg";
export const url = url_;